module.exports = __webpack_public_path__ + "static/media/af.14c45ecc.svg";